ux-iws-comparison-table {
    display: block;
    position: relative;
    max-width: 100%;
    overflow: visible;

    .footnotes-reference {
        white-space: nowrap;

        &::before {
            @include font("bold");
            content: "*";
            display: inline-block;
        }
    }
}

.ux-iws-comparison-table {
    &__table {
        display: block;
        position: relative;
        overflow: auto;
        max-width: 100%;
        -webkit-overflow-scrolling: touch;
    }

    &__overlay {
        position: absolute;
        pointer-events: none;
        z-index: 1;
        inset: 0;

        &--cropped {
            overflow: hidden;
        }
    }

    &__gradient {
        position: absolute;
        height: 100%;
        width: 80px;
        top: 0;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.5s ease;

        &--left {
            left: 0;
            right: auto;
            background: linear-gradient(
                to right,
                rgba(0, 0, 0, 0.3) 0,
                rgba(0, 0, 0, 0) 100%
            );
        }

        &--right {
            left: auto;
            right: 0;
            background: linear-gradient(
                to right,
                rgba(255, 255, 255, 0) 0,
                #fff 90%
            );
        }

        &--cropped {
            opacity: 1;
            z-index: 1;
        }
    }

    table {
        border-collapse: collapse;
        outline: none;

        &:focus-visible {
            outline: 1px auto $color-black;
            outline-offset: -1px;
        }
    }

    th {
        @include font("bold");
        text-align: left;
    }
}

.ux-iws-comparison-table--full-width {
    table {
        width: 100%;
    }
}

.ux-iws-comparison-table--content {
    td,
    th {
        border: 0 none transparent;
        padding: 26px 10px 26px 30px;

        &:last-child {
            padding-right: 30px;
        }
    }

    th {
        font-size: 0.75rem;
        text-transform: uppercase;
    }

    thead {
        background-color: $color-blue-highlight-3;
    }

    thead td,
    thead th {
        background-color: $color-blue-highlight-3;
        color: $color-white;
    }

    /* stylelint-disable selector-max-compound-selectors */
    tbody tr:first-child th,
    tbody tr:first-child td {
        box-shadow: inset 0 82px 50px -74px rgba(19, 19, 19, 0.15);
    }
    /* stylelint-enable selector-max-compound-selectors */
}

.ux-iws-comparison-table--data {
    td,
    th {
        border: 1px solid #cbcbcb;
        padding: 10px;
    }

    thead,
    thead td,
    thead th {
        background-color: $color-blue-highlight-3;
        color: $color-white;
    }

    th:first-child,
    td:first-child {
        border-left-color: transparent;
    }

    th:last-child,
    td:last-child {
        border-right-color: transparent;
    }

    th {
        font-size: 0.75rem;
    }

    .cat td,
    .cat th {
        background-color: $color-blue-highlight-6;
        text-transform: uppercase;
    }

    .sub-cat td,
    .sub-cat th {
        background-color: $color-white;
    }

    .sub-cat th {
        font-size: 0.75rem;
        text-transform: none;
    }

    .sub-cat td:not(:first-child) {
        white-space: nowrap;
    }

    @media only screen and (min-width: 768px) {
        td,
        th {
            padding: 15px 30px;
        }
    }
}

.ux-iws-comparison-table--data {
    thead,
    thead td,
    thead th {
        color: $color-black-text;
        background-color: $color-white;
        border-color: transparent;
        border-top-width: 0;
        border-bottom-width: 0;
    }

    /* stylelint-disable selector-max-compound-selectors */
    tbody .cat th,
    tbody .cat td {
        background-color: $color-gray-table-bg;
    }
    /* stylelint-enable selector-max-compound-selectors */
}

.ux-iws-comparison-table--no-border {
    th,
    td {
        border-left-color: transparent;
        border-right-color: transparent;
    }
}

.ux-iws-comparison-table__header,
.ux-iws-comparison-table__row-header {
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s ease;

    &--sticky {
        opacity: 1;
    }
}

.ux-iws-comparison-table__header {
    width: 100%;
    background-color: $color-white;
    box-shadow: 0 20px 20px -20px rgba(0, 0, 0, 0.075);
}

.ux-iws-comparison-table__row-header {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;

    td,
    th {
        border-width: 0.5px !important;
        position: absolute;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    tbody {
        box-shadow: 20px 0 20px -20px rgba(0, 0, 0, 0.15);
    }

    thead {
        opacity: 0;
    }
}
